import { FC } from "react";
import { useNavigate } from "react-router-dom";

interface PromotionBannerProps {
  ignoreAuth?: boolean;
}

/**
 * 登录页新用户引导横幅。
 * 仅由 /login（AuthPage.tsx）以 ignoreAuth 形式调用，强制对所有人展示。
 * 没有关闭按钮，固定显示。
 */
const PromotionBanner: FC<PromotionBannerProps> = ({ ignoreAuth = false }) => {
  const navigate = useNavigate();
  if (!ignoreAuth) return null;

  const handleArrowClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate("/login");
  };

  return (
    <div
      style={{
        background: "#000",
        color: "#fff",
        padding: "10px 48px 10px 16px",
        fontSize: 14,
        textAlign: "center",
        fontFamily: "'Inter','PingFang SC','Microsoft YaHei',sans-serif",
        lineHeight: 1.5,
        letterSpacing: "0.3px",
        position: "relative",
      }}
    >
      <span>
        🎉 新用户注册即送{" "}
        <strong style={{ color: "#fbbf24" }}>500 积分</strong>
        ，可生成 2500 秒 AI音频。
      </span>
      <span
        onClick={handleArrowClick}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: 6,
          color: "#fbbf24",
          textDecoration: "none",
          fontSize: 16,
          fontWeight: 700,
          verticalAlign: "middle",
          cursor: "pointer",
          transition: "transform 0.2s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "translateX(3px)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "translateX(0)")}
        title="立即注册"
      >
        →
      </span>
    </div>
  );
};

export default PromotionBanner;